/**
 * Results.
 */
export const CORRECT = "correct";
export const INCORRECT = "incorrect";

/**
 * Games Types.
 */
export const GAME_SPEED_READING = "speed_reading";

/**
 * Fonts types.
 */
export const COMPUTER = "computer";
export const HANDWRITING = "handwriting";
